import { createSlice } from "@reduxjs/toolkit";
import { configApi } from "./config.api";
// Api response type
const initialState = {
    config: {
        assetsPrefix: "",
        country: "",
        banner: "",
        termsAndConditions: ""
    },
    dictionary: {
        LXL_COMPONENTS_ERROR_TITLE: "Something went wrong!",
        LXL_COMPONENTS_ERROR_SUBTITLE: "Please click below to reload the section.",
        LXL_COMPONENTS_ERROR_ACTION: "RELOAD"
    }
};
export const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        setLocale: (state, action) => void (state.locale = action.payload)
    },
    extraReducers: (builder) => {
        builder.addMatcher(configApi.endpoints.getConfig.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
export const { setLocale } = configSlice.actions;
//# sourceMappingURL=config.slice.js.map